export default __webpack_public_path__ + "static/media/slide1.3.289ba311.jpg";